import { render, staticRenderFns } from "./joinClass.vue?vue&type=template&id=1bc7c5ba&"
import script from "./joinClass.vue?vue&type=script&lang=js&"
export * from "./joinClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports